export var DoctissimoTaxonomyName;

(function (DoctissimoTaxonomyName) {
  DoctissimoTaxonomyName["PersonType"] = "DOCTISSIMO_FR_PERSON_TYPE";
  DoctissimoTaxonomyName["MainSection"] = "DOCTISSIMO_FR_MAIN_SECTION";
})(DoctissimoTaxonomyName || (DoctissimoTaxonomyName = {}));